import { render } from "./AnimatedCursor.vue?vue&type=template&id=2ca71098&scoped=true"
import script from "./AnimatedCursor.vue?vue&type=script&lang=js"
export * from "./AnimatedCursor.vue?vue&type=script&lang=js"

import "./AnimatedCursor.vue?vue&type=style&index=0&id=2ca71098&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2ca71098"

export default script